<div class="alert">
    <mat-icon>check_circle</mat-icon> You have <span class="total">{{total}}</span> tasks assigned to you.
</div>
